import Vue from "vue";
import VueRouter from "vue-router";
import Recipes from "../views/Recipes.vue";
import store from "../store";

Vue.use(VueRouter);

function createBackButtonComponent(route, options) {
  return Vue.component("BackButton", {
    render(createElement) {
      return createElement(
        "a",
        { on: { click: this.navigate }, class: "nav__link" },
        "Terug"
      );
    },
    template: `
      <router-link :to="route" />
    `,
    methods: {
      navigate() {
        if (options.appendParam) {
          if (!options.paramName) throw "paramName is required";
          const param = this.$route.params[options.paramName];
          return this.$router.push(`${route}/${param}`);
        }

        return this.$router.push(route);
      },
    },
  });
}

const routes = [
  {
    path: "/",
    name: "recipes",
    component: Recipes,
    beforeEnter(to, from, next) {
      const interval = setInterval(() => {
        if (store.getters.accessToken) {
          store.dispatch("getRecipes");
          clearInterval(interval);
        }
      }, 200);
      next();
    },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/recipe/:id",
    name: "Recept",
    meta: {
      leftNavComponent: createBackButtonComponent("/", {}),
    },
    component: () =>
      import(/* webpackChunkName: "add recipe" */ "../views/ShowRecipe.vue"),
  },
  {
    path: "/add-recipe",
    name: "Recept toevoegen",
    component: () =>
      import(/* webpackChunkName: "add recipe" */ "../views/AddRecipe.vue"),
  },
  {
    path: "/edit-recipe/:id",
    name: "Recept aanpassen",
    meta: {
      leftNavComponent: createBackButtonComponent("/recipe", {
        appendParam: true,
        paramName: "id",
      }),
    },
    component: () =>
      import(/* webpackChunkName: "edit recipe" */ "../views/EditRecipe.vue"),
  },
  {
    path: "/users",
    name: "Gebruikers",
    component: () =>
      import(/* webpackChunkName: "edit recipe" */ "../views/Users.vue"),
  },
  {
    path: "/add-user",
    name: "Add user",
    component: () =>
      import(/* webpackChunkName: "edit recipe" */ "../views/AddUser.vue"),
  },
  {
    path: "/user/:id",
    name: "User",
    component: () =>
      import(/* webpackChunkName: "edit user" */ "../views/EditUser.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function isAuthenticated() {
  const user = JSON.parse(localStorage.getItem("accessToken"));

  if (user && user.accessToken) return true;
  return false;
}

router.beforeEach((to, from, next) => {
  if (to.name === "login" && isAuthenticated()) next({ name: "recipes" });
  else if (to.name === "login" || isAuthenticated()) next();
  else next({ name: "login" });
});

export default router;
